import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Definition } from "../../vo/definition";

@Component({
	selector: "app-definition-popup",
	templateUrl: "./definition-popup.component.html",
	styleUrls: ["./definition-popup.component.css"],
})
export class DefinitionPopupComponent {
	@Input()
	public definition: any;
	@Output()
	private closeDefinitionEvent: EventEmitter<string> = new EventEmitter<string>();
	//private definition:Definition;

	constructor() {}

	closePopup() {
		this.definition.title = "";
		this.definition.bodyText = "";
		this.closeDefinitionEvent.emit("");
	}
}
